import { Component, Input } from '@angular/core';
import { ClientPrescriberTask } from '../../../core/models/client-prescriber-task.model';
import { PrescriberIncorrectInformationPromptComponent } from '../../../shared/components/prescriber-incorrect-information-prompt/prescriber-incorrect-information-prompt.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { PrescriptionNameComponent } from '../../../shared/components/prescription-name/prescription-name.component';
import { ClientTaskEncountersComponent } from '../client-task-encounters/client-task-encounters.component';
import { ClientPrescriberTaskRelatedTasksComponent } from '../client-prescriber-task-related-tasks/client-prescriber-task-related-tasks.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-client-prescriber-task-details',
    templateUrl: './client-prescriber-task-details.component.html',
    styleUrls: ['./client-prescriber-task-details.component.scss'],
    imports: [PrescriberIncorrectInformationPromptComponent,
              PrescriberNameComponent,
              PrescriptionNameComponent,
              ClientTaskEncountersComponent,
              ClientPrescriberTaskRelatedTasksComponent,
              DatePipe]
})
export class ClientPrescriberTaskDetailsComponent {
  @Input() task: ClientPrescriberTask;
}
